<template>
  <a v-if="isExternalLink || isAnchorLink || isAppReturnLink" v-bind="$attrs" :href="to.toString()" :target="isExternalLink ? '_blank' : '_self'">
    <slot />
  </a>
  <RouterLink v-else v-bind="$props" custom v-slot="{ href, navigate }">
    <a v-bind="$attrs" :href="href" @click="navigate">
      <slot />
    </a>
  </RouterLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { RouterLink, type RouterLinkProps } from 'vue-router'
import { useAppReturnLinkStore } from '@/store/AppReturnLinkStore'
import { storeToRefs } from 'pinia'

const appReturnLinkStore = useAppReturnLinkStore()
const { appReturnLink } = storeToRefs(appReturnLinkStore)

const props = defineProps<RouterLinkProps>()
const isString = typeof props.to === 'string'

const isAppReturnLink = computed(() => isString && props.to === appReturnLink.value)
const isExternalLink = computed(() => isString && props.to.startsWith('http'))
const isAnchorLink = computed(() => isString && props.to.startsWith('#'))
</script>
